export default "__VITE_ASSET__CcXM57rS__"